// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.c-popup {
  display: none;
}

.c-popup.is-active {
  display: block;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background: var(--white);
  box-shadow: var(--shadow);
  border-radius: 4px;
  min-width: 80%;
  z-index: 101; /* Keep above all other items. */
}

.c-popup__inner {
  padding: 32px 0;
}

.c-popup__survey {
  padding: 8px 32px;
}

.c-popup__exit {
  position: absolute;
  top: 12px;
  right: 12px;
  background: none;
  border: none;
  height: 32px;
  width: 32px;
}

.c-toast__bar {
  --icon-color: var(--white);

  background: var(--black);
  position: fixed;
  bottom: 12px;
  right: 12px;
  /* Add me back in for Map */
  /* padding: 12px 16px;
  border-radius: 36px; */
  padding: 12px;
  border-radius: 25%;
  box-shadow: var(--shadow);
  transition: transform 1s ease-in-out;
  z-index: 1; /* Low priority z-index */
}

.c-toast__bar.is-hidden {
  animation: slideDown 1s forwards;
}

.c-toast__bar.is-active {
  animation: slideUp 1s forwards;
}

.c-toast__btn {
  border: none;
  background: var(--black);
  border-radius: 50%;
  height: 40px;
  width: 40px;
}

.c-toast__btn-icon {
  color: var(--icon-color);
}

@media only screen and (min-width: 768px) {
  .c-toast__btn:hover {
    --icon-color: var(--black);
    
    color: var(--black);
    background: var(--white);
    transition: 0.7s;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/toast.css"],"names":[],"mappings":"AAAA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,wBAAwB;EACxB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY,EAAE,gCAAgC;AAChD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,0BAA0B;;EAE1B,wBAAwB;EACxB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,2BAA2B;EAC3B;wBACsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,oCAAoC;EACpC,UAAU,EAAE,yBAAyB;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,wBAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;;IAE1B,mBAAmB;IACnB,wBAAwB;IACxB,gBAAgB;EAClB;AACF","sourcesContent":[".c-popup {\n  display: none;\n}\n\n.c-popup.is-active {\n  display: block;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  background: var(--white);\n  box-shadow: var(--shadow);\n  border-radius: 4px;\n  min-width: 80%;\n  z-index: 101; /* Keep above all other items. */\n}\n\n.c-popup__inner {\n  padding: 32px 0;\n}\n\n.c-popup__survey {\n  padding: 8px 32px;\n}\n\n.c-popup__exit {\n  position: absolute;\n  top: 12px;\n  right: 12px;\n  background: none;\n  border: none;\n  height: 32px;\n  width: 32px;\n}\n\n.c-toast__bar {\n  --icon-color: var(--white);\n\n  background: var(--black);\n  position: fixed;\n  bottom: 12px;\n  right: 12px;\n  /* Add me back in for Map */\n  /* padding: 12px 16px;\n  border-radius: 36px; */\n  padding: 12px;\n  border-radius: 25%;\n  box-shadow: var(--shadow);\n  transition: transform 1s ease-in-out;\n  z-index: 1; /* Low priority z-index */\n}\n\n.c-toast__bar.is-hidden {\n  animation: slideDown 1s forwards;\n}\n\n.c-toast__bar.is-active {\n  animation: slideUp 1s forwards;\n}\n\n.c-toast__btn {\n  border: none;\n  background: var(--black);\n  border-radius: 50%;\n  height: 40px;\n  width: 40px;\n}\n\n.c-toast__btn-icon {\n  color: var(--icon-color);\n}\n\n@media only screen and (min-width: 768px) {\n  .c-toast__btn:hover {\n    --icon-color: var(--black);\n    \n    color: var(--black);\n    background: var(--white);\n    transition: 0.7s;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
